import React, { useState, useRef } from "react";
import { capitalCase } from "change-case";
import Loader from "./Loader";

const FileUpload = (props) => {
  const {
    buttonLabel = "file(s)",
    uploadSuccessfulHandler = async (res) => {},
    uploadFailureHandler = async (err) => {},
    uploadInProgress,
    setUploadInProgress,
    onFilesDeleted,
    uploadSuccess,
    setUploadSuccess,
    allowedTypes,
    multiple = false,
  } = props;

  const [pristine, setPristine] = useState(true);

  const inputField = useRef(null);
  const handleChange = async (e) => {
    setPristine(false);
    setUploadInProgress(true);

    const fileList = e.target?.files;
    if (fileList?.length > 0) {
      try {
        // All files uploaded successfully.
        return await uploadSuccessfulHandler(Array.from(fileList));
      } catch (err) {
        // Some file did not upload correctly.
        // Ask to upload all again.
        setUploadSuccess(false);
        setUploadInProgress(false);
        return await uploadFailureHandler(err);
      }
    } else {
      setUploadInProgress(false);
      setUploadSuccess(false);
      setPristine(true);
    }

    return await uploadFailureHandler(fileList);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    if (inputField?.current) {
      const deletedFiles = inputField.current.value;
      inputField.current.value = null;
      setUploadInProgress(false);
      setPristine(true);
      onFilesDeleted(deletedFiles);
    }
  };

  return (
    <div className="form-group mb-2 d-flex align-items-start justify-content-center flex-column">
      <label className="form-label fw-b">
        {"Upload " + capitalCase(buttonLabel)}
      </label>
      <div className="d-flex flex-row align-items-center justify-content-between w-25">
        <div
          className="d-flex flex-row align-items-center justify-content-start"
          style={{ marginRight: "20px" }}
        >
          <input
            type="file"
            ref={inputField}
            accept={allowedTypes}
            multiple={multiple}
            onChange={handleChange}
            style={{
              maxWidth: "220px",
              marginRight: "5px",
            }}
            className="form-control-file"
          />
          <button
            style={{
              width: "20px",
              height: "20px",
            }}
            className="footer-icon trash_can"
            onClick={handleDelete}
          ></button>
        </div>
        {pristine && <div style={{ height: "20px", width: "20px" }} />}
        {!pristine && (
          <Loader
            width={"20px"}
            height={"20px"}
            loading={uploadInProgress}
            success={uploadSuccess}
            error={!uploadSuccess}
          />
        )}
      </div>
    </div>
  );
};

export default FileUpload;
